import { GlassCard } from "./ui";

/* Reusable "coming soon" panel for portal sections not yet built (Phase 2+). */
export function PortalPlaceholder({ icon: Icon, title, description, phase = "Phase 2" }) {
  return (
    <div className="space-y-6" data-testid="portal-placeholder">
      <div>
        <h1 className="font-playfair text-2xl sm:text-3xl text-white">{title}</h1>
        {description && <p className="mt-2 text-muted-foreground max-w-2xl">{description}</p>}
      </div>
      <GlassCard className="p-12 flex flex-col items-center text-center" hover={false}>
        {Icon && (
          <div className="grid place-items-center h-14 w-14 rounded-2xl bg-gold/10 border border-gold/20">
            <Icon className="h-7 w-7 text-gold" />
          </div>
        )}
        <p className="mt-5 font-playfair text-xl text-white">Arriving in {phase}</p>
        <p className="mt-2 text-sm text-muted-foreground max-w-md">
          This section is part of the foundation shell. Full functionality is scheduled for {phase} of the roadmap.
        </p>
      </GlassCard>
    </div>
  );
}
